export default __webpack_public_path__ + "static/1-c89ac05a8fbf93575ed90e0922df9298.png";